import { render, staticRenderFns } from "./UserAccountView.vue?vue&type=template&id=b2f8c736"
import script from "./UserAccountView.vue?vue&type=script&lang=js"
export * from "./UserAccountView.vue?vue&type=script&lang=js"
import style0 from "./UserAccountView.vue?vue&type=style&index=0&id=b2f8c736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports